<script lang="ts">
  import MembersForm from "$app/Pages/Signup/MembersForm.svelte"
  import { catchError, formatter, toast, xhr } from "$app/utils"
  import Coupon from "$app/Pages/Signup/Coupon.svelte"
  import Card from "$app/Pages/Signup/Card.svelte"
  import SaveButton from "$app/Pages/Signup/SaveButton.svelte"
  import { slide } from "svelte/transition"
  import { appStore } from "$app/store.svelte"
  import { signupStore } from "$app/signupstore.svelte"
  import { onMount } from "svelte"

  let { oncomplete }: { oncomplete: (subscription: SubscriptionType) => void } =
    $props()

  let saving = $state(false)
  let card = $state<Card>(null)

  async function getData(): Promise<any> {
    const auth_token_input = <HTMLInputElement>(
      document.getElementById("x-csrf-token")
    )
    const auth_token = auth_token_input?.value || ""

    const cardToken = await card.getStripeToken()
    if (cardToken === "") {
      toast(
        "There was an error with the credit card verification. Please try again.",
        "error"
      )
      saving = false
      return
    }

    return {
      subscription: {
        stripe_token: cardToken,
        billing_interval: signupStore.billingInterval,
        discount: signupStore.discount,
        subscription_type: "standard",
        name: signupStore.selectedPlan.name,
        stripe_coupon: signupStore.coupon.id,
        full_access_total: signupStore.signupCount("full_access"),
        team_member_total: signupStore.signupCount("team_member"),
        recognition_member_total: signupStore.signupCount("recognition_member"),
        auth_token: auth_token
      }
    }
  }

  async function handleSubmit(): Promise<void> {
    saving = true
    const data = await getData()
    const [error, resp] = await catchError(
      xhr.post<{
        plan: PlanType
        subscription: SubscriptionType
      }>(`/plans/${appStore.plan.id}/admin/billing/upgrade_to_standard`, {
        ...data
      })
    )

    if (error) {
      toast(
        "There are some errors. Please verify and try again or contact support@leadwithpurpose.com.",
        "error",
        { duration: 30000 }
      )
      saving = false
      return
    }

    saving = false
    toast(
      "Congratulations! You have successfully upgraded to the Standard Plan 🎉",
      "success"
    )
    appStore.plan = resp.data.plan
    signupStore.subscription = resp.data.subscription
    signupStore.stripe_data = resp.data.stripe_data
    oncomplete(resp.data.subscription)
  }

  onMount(() => {
    signupStore.prepareFreeMembers()
  })
</script>

<div transition:slide class="max-w-xl mx-auto shadow-md border rounded-md py-4">
  <div class="px-2 md:px-4">
    <MembersForm>
      {#snippet discountSnippet()}
        <div class="grid grid-cols-3 gap-2">
          <div class="col-span-2 flex items-center gap-1">
            Discount
            <Coupon onvalidating={(validating) => (saving = validating)} />
          </div>
          <div class="font-bold text-right leading-12">
            - {formatter.format(signupStore.discount)}
          </div>
        </div>
      {/snippet}
    </MembersForm>
  </div>

  <hr class="text-gray-200" />

  <div class="px-2 py-8 md:px-4 mt-4">
    <Card bind:this={card} />
  </div>

  <div class="px-2 md:px-4">
    <SaveButton
      bind:saving
      title="Upgrade to Standard"
      onclick={handleSubmit}
    />
  </div>
</div>
